// extracted by mini-css-extract-plugin
export var responsibility = "index-module--responsibility--CtULx";
export var socialResponsibilities = "index-module--socialResponsibilities--NYVNZ";